import Component from '../inherited/Component'

export default class Tabs extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._tabLinks = this._elem.querySelectorAll('[data-tab-link]')
    this._tabContents = this._elem.querySelectorAll('[data-tab-content]')
  }

  mount () {
    for (let elem of this._tabLinks) {      
      elem.addEventListener('click', e => {
        let tabId = elem.dataset.tabLink.toString()

        for (let elem of this._tabLinks) {
          elem.classList.remove('active')
        }
        for (let elem of this._tabContents) {
          elem.classList.remove('active')
        }

        elem.classList.add('active')
        document.getElementById(tabId).classList.add('active')

        if (this._options.updateKeenSlider) {
          let slider = this._theme.getComponentByElem(document.getElementById(tabId).querySelector('[data-keen-slider]'))
          slider.component._slider.update()
        }
      })
    }
  }
}